import { render, staticRenderFns } from "./FiltersModal.vue?vue&type=template&id=bd60b2aa&scoped=true"
import script from "./FiltersModal.vue?vue&type=script&lang=ts"
export * from "./FiltersModal.vue?vue&type=script&lang=ts"
import style0 from "./FiltersModal.vue?vue&type=style&index=0&id=bd60b2aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd60b2aa",
  null
  
)

export default component.exports